'use client'

import { Smartphone, Globe, Zap, Tablet } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function MobileAppDevelopmentPage() {
  return (
    <ServicePageTemplate
      slug="mobile-app-development"
      title="Mobile App"
      titleHighlight="Development"
      description="Custom, cross-platform, and enterprise mobile apps that deliver seamless user experiences with focus on UI/UX design."
      accentColor="from-pink-500 to-rose-600"
      stats={[
        { value: '200+', label: 'Apps Delivered' },
        { value: '50M+', label: 'Downloads Generated' },
        { value: '4.9★', label: 'Average Rating' },
        { value: '99%', label: 'Client Satisfaction' }
      ]}
      services={[
        { icon: <Smartphone className="w-6 h-6" />, title: 'Native iOS Development', description: 'Swift-based native iOS apps optimized for performance.', features: ['Swift & SwiftUI', 'Core Data Integration', 'App Store Optimization', 'Push Notifications'] },
        { icon: <Tablet className="w-6 h-6" />, title: 'Native Android Development', description: 'Kotlin-based native Android apps with material design.', features: ['Kotlin & Jetpack Compose', 'Firebase Integration', 'Google Play Console', 'Material Design 3'] },
        { icon: <Globe className="w-6 h-6" />, title: 'Cross-Platform Development', description: 'React Native and Flutter apps across platforms.', features: ['React Native & Flutter', 'Shared Codebase', 'Platform-specific UI', 'Performance Optimization'] },
        { icon: <Zap className="w-6 h-6" />, title: 'Progressive Web Apps', description: 'Web-based apps with native-like experience.', features: ['Offline Functionality', 'Push Notifications', 'App Shell Architecture', 'Service Workers'] },
      ]}
      technologies={[
        { name: 'React Native', category: 'Cross-Platform' }, { name: 'Flutter', category: 'Cross-Platform' },
        { name: 'Swift', category: 'iOS Native' }, { name: 'Kotlin', category: 'Android Native' },
        { name: 'Firebase', category: 'Backend' }, { name: 'GraphQL', category: 'API' },
        { name: 'Redux', category: 'State Mgmt' }, { name: 'AWS Amplify', category: 'Cloud' },
      ]}
      process={[
        { step: '01', title: 'Discovery & Planning', description: 'Understand requirements, target audience, and business goals.' },
        { step: '02', title: 'UI/UX Design', description: 'Create intuitive designs with wireframes and prototypes.' },
        { step: '03', title: 'Development', description: 'Build native or cross-platform apps with clean architecture.' },
        { step: '04', title: 'Testing & QA', description: 'Comprehensive testing on multiple devices and OS versions.' },
        { step: '05', title: 'App Store Submission', description: 'Handle submission process for iOS and Android stores.' },
        { step: '06', title: 'Post-Launch Support', description: 'Ongoing updates, bug fixes, and feature enhancements.' },
      ]}
    />
  )
}
